module.exports = __webpack_public_path__ + "static/featured-acm-repairs-cc13f8bc46017929598a10594d0c7c1e.png";